import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

export const getFieldContentConfig = (
    fieldStatus,
    forcedImport,
    enableForcedImport,
    handleExportSubmit,
    handleForcedImportSubmit,
    handleImportSubmit
) => {
    const fieldContentMap = {
        not_exported: {
            statusTitle:
                "1/3. Enviar a autorização para a equipa de vistoria ao terreno",
            statusInfo: (
                <>
                    <Typography variant="body2">
                        Você vai enviar os dados da autorização para que a equipa da
                        vistoria possa accessar a elos desde o telemóvel.
                    </Typography>
                    <Typography variant="body2" style={{marginTop: 0}}>
                        Após a exportação,
                        <Typography component="span" variant="body2" fontWeight="bold">
                            {" "}
                            o processo será bloqueado{" "}
                        </Typography>
                        até que os dados de terreno sejam actualizados.
                    </Typography>
                </>
            ),
            statusAlert:
                "Verifique se os dados de autorização estão correctos antes de continuar.",
            textButton: "Enviar autorização",
            onConfirm: handleExportSubmit,
        },
        exported_not_changed: {
            statusTitle: "2/3. Continue sem os dados de terreno",
            statusInfo: (
                <>
                    <Typography variant="body2">
                        A autorização foi enviada para o telemóvel, mas os dados do
                        terreno ainda não foram actualizados.
                    </Typography>
                    <Typography variant="body2" style={{marginTop: 0}}>
                        Você pode continuar o processo e adicionar os dados de terreno
                        <Typography component="span" variant="body2" fontWeight="bold">
                            {" "}
                            manualmente{" "}
                        </Typography>
                        mais tarde mas
                        <Typography component="span" variant="body2" fontWeight="bold">
                            {" "}
                            não poderá importar os dados{" "}
                        </Typography>
                        de terreno do telemóvel.
                    </Typography>
                    <Typography variant="body2">
                        Ou pode
                        <Typography component="span" variant="body2" fontWeight="bold">
                            {" "}
                            esperar que a equipa da vistoria actualize os dados do
                            terreno{" "}
                        </Typography>
                        para importá-los automaticamente.
                    </Typography>
                </>
            ),
            statusAlert:
                "Se tiver certeza de que deseja continuar o processo sem os dados de terreno, acrescente o código da autorização.",
            textButton: "Continuar sem os dados de terreno",
            isButtonDisabled: !forcedImport,
            onConfirm: handleForcedImportSubmit,
            input: (
                <TextField
                    id="outlined-basic"
                    label="Código da autorização"
                    variant="outlined"
                    onChange={event => enableForcedImport(event.target.value)}
                />
            ),
        },
        exported_and_changed: {
            statusTitle: "2/3. Importe os dados de terreno registrados no telemóvel",
            statusAlert:
                "Os dados de terreno já foram acrescentados no telemóvel. Agora você pode importar os dados de terreno para continuar o processo.",
            alertSeverity: "info",
            textButton: "Importar os dados de terreno",
            onConfirm: handleImportSubmit,
        },
        imported: {
            statusTitle: "3/3. Acrescente os dados da vistoria",
            statusAlert:
                "Os dados de terreno já foram importados desde o telemóvel. Preencha os dados da vistoria e continue com o processo.",
            alertSeverity: "success",
        },
        forced_imported: {
            statusTitle: "3/3. Acrescente os dados da vistoria",
            // TO-DO: Si no se rellenan los campos de la visita no se puede avanzar. ¿Y si no hay datos de la visita porque no se ha realizado?
            statusAlert:
                "Nenhum dado de terreno foi importado. Preencha os dados da vistoria e avance para o passo seguinte para acrescentar os dados de terreno.",
            alertSeverity: "info",
        },
    };

    return (
        fieldContentMap[fieldStatus] || {
            statusAlert: "Estado do processo desconhecido.",
            alertSeverity: "error",
        }
    );
};
